<template>
  <div :class="{ 'dark-mode': isSupplierOne }">
    <!-- <LazyDiscoverResellerCategoryOnlyCategories
      :category-list="categories.filter((category) => category.title)"
      :dark-mode="isSupplierOne"
    />
    <div class="container mt-10 category-only">
      <template v-if="activeCategory">
        <h1>
          <div v-if="$te(`discover.${activeCategory.slug}.h1`)">
            <span
              class="md:text-heading-2 text-mobile-heading-2 text-primary-2"
            >
              {{ $t(`discover.${activeCategory.slug}.h1`) }}
            </span>
          </div>
          <div v-else>
            <div class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
              {{ t("discover.exploreTheBest") }}
            </div>
            <div
              class="rtl:hidden md:text-heading-2 text-mobile-heading-2 text-primary-2"
            >
              {{ activeCategory.title }} {{ t("experiences") }}
            </div>
          </div>
        </h1>
        <p
          class="ltr:hidden md:text-heading-2 text-mobile-heading-2 text-primary-2"
        >
          <template v-if="locale !== 'ar'">
            {{ t("experiences") }}
          </template>
          {{ activeCategory.title }}
        </p>
      </template>
      <template v-else>
        <template v-if="activeLabels.length">
          <p class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
            {{ t("discover.exploreTheBestLabel") }}
          </p>
          <p
            class="md:text-heading-2 text-mobile-heading-2 text-primary-2 mt-2"
          >
            <template v-for="(label, index) in activeLabels" :key="label.slug">
              <span class="capitalize">{{ label.value }}</span>
              <span
                v-if="(index as number) < activeLabels.length - 1"
                class="text-black"
              >
                &amp;
              </span>
            </template>
          </p>
        </template>
        <template v-else>
          <p class="md:text-heading-2 text-mobile-heading-2 text-primary-1">
            {{ t("discover.allTheBest") }}
          </p>
          <p class="md:text-heading-2 text-mobile-heading-2 text-primary-2">
            {{ t("discover.toursActivitiesWorldwide") }}
          </p>
        </template>
      </template>
    </div> -->

    <div v-if="categoryH1" class="container pt-8 md:pt-12">
      <h1
        class="text-mobile-heading-2 md:text-heading-2 text-primary-1 capitalize leading-tight"
      >
        {{ categoryH1 }}
      </h1>
      <!-- <span
        class="block mt-3 h-1 w-14 rounded-full bg-primary-2"
        aria-hidden="true"
      /> -->
    </div>
    <LazyExperienceList
      :class="categoryH1 ? 'md:!pt-8 pt-5' : 'md:!pt-[50px] pt-5'"
      class="mb-16"
      :initial-facets="discoverFacets"
      :locked-category-slug="activeCategorySlug"
      :dark-mode="isSupplierOne"
      is-general
    />
  </div>
</template>

<script lang="ts" setup>
import { useAsyncData } from "nuxt/app";
import { useRoute } from "vue-router";
import type { ITestimonial } from "../../../../types/general";
const route = useRoute();
const { t, locale } = useI18n();

/** The `/[categorySlug]` route's own path segment — "things-to-do" is a
 *  reserved sentinel meaning "no specific category" (the bare "all
 *  categories" page), not a real category, so it's treated the same as no
 *  slug at all here. Passed to `ExperienceList` as a locked filter (baked
 *  into the URL, not a removable checkbox) rather than a normal query
 *  filter — `useExperienceListFilters` already supports this via its
 *  `lockedCategorySlug` option. */
const activeCategorySlug = computed(() => {
  const slug = route.params.categorySlug as string | undefined;
  return slug && slug !== "things-to-do" ? slug : undefined;
});

const [
  { data: discoverFacets },
  { data: categoryMeta },
  { data: products },
  { data: meta },
] = await Promise.all([
  useAsyncData<any>(
    "category-facets",
    () =>
      customFetch(`api/v2/products/facets?lang=${locale.value}`, locale.value),
    { watch: [locale] }
  ),
  // Skipped entirely when no category is selected (the old code always hit
  // this endpoint, even with the "things-to-do" sentinel slug that was never
  // a real category) — `categoryMetaTags` below already falls back to the
  // generic `experiences-meta` fetch in that case.
  useAsyncData<any>(
    "category-meta",
    () =>
      activeCategorySlug.value
        ? customFetch(
            `api/meta-data/category/${activeCategorySlug.value}`,
            locale.value
          )
        : Promise.resolve(null),
    { watch: [locale, activeCategorySlug] }
  ),
  // `getQuery()` only reads route.query (additional, removable filters) — the
  // locked route.params.categorySlug needs its own `filter[category]` append.
  useAsyncData<any>(
    "products-list-cat",
    () =>
      customFetch(
        `api/v2/products?per_page=30&${getQuery()}${activeCategorySlug.value ? `&filter[category]=${activeCategorySlug.value}` : ""}`
      ),
    { watch: [activeCategorySlug] }
  ),
  useAsyncData<any>("experiences-meta", () =>
    customFetch("api/meta-data/page/experiences")
  ),
]);
const categoryMetaTags = computed(() =>
  categoryMeta.value?.title ? categoryMeta.value : meta.value
);
const runtimeConfig = useRuntimeConfig();
const layout = runtimeConfig.public.layout;
const isSupplierOne = ref(false);
isSupplierOne.value = layout.type?.includes("supplier-one") ?? false;

const categories = computed(() => discoverFacets.value?.categories ?? []);

const activeCategory = computed(() =>
  categories.value.find(
    (category) => category.slug === activeCategorySlug.value
  )
);
console.log("categoryMeta.value", categoryMeta.value);
/** Page H1: the per-category `h1` field from the panel's category meta data
 *  when it's set, otherwise the category name. No H1 on the bare
 *  "things-to-do" page (no category selected). */
const categoryH1 = computed(
  () => categoryMeta.value?.heading?.trim() || activeCategory.value?.title || ""
);

const activeLabels = computed(() => {
  if (!route.query.label || !discoverFacets.value?.labels) return [];
  const labelSlugs = route.query.label.toString().split(",");
  return discoverFacets.value.labels.filter((label) =>
    labelSlugs.includes(label.slug)
  );
});

function getQuery() {
  let queryTemp = "";
  if (route.path.includes("search")) {
    queryTemp = `${queryTemp}filter[search]=${route.params.searchText}&`;
  }
  if (Object.keys(route.query).length) {
    if (route.query.category) {
      queryTemp = `${queryTemp}filter[category]=${route.query.category}&`;
    }
    if (route.query.city) {
      queryTemp = `${queryTemp}filter[city]=${route.query.city}&`;
    }
    if (route.query.label) {
      queryTemp = `${queryTemp}filter[label]=${route.query.label}&`;
    }
    if (route.query.area) {
      queryTemp = `${queryTemp}filter[area]=${route.query.area}&`;
    }
    if (route.query["best-time"]) {
      queryTemp = `${queryTemp}filter[attribute][best-time]=${route.query["best-time"]}&`;
    }
    if (route.query["duration"]) {
      queryTemp = `${queryTemp}filter[attribute][duration]=${route.query["duration"]}&`;
    }
    if (route.query["perfect-for"]) {
      queryTemp = `${queryTemp}filter[attribute][perfect-for]=${route.query["perfect-for"]}&`;
    }
    if (route.query["age-range"]) {
      queryTemp = `${queryTemp}filter[attribute][age-range]=${route.query["age-range"]}&`;
    }
    if (route.query["transport"]) {
      queryTemp = `${queryTemp}filter[attribute][transport]=${route.query["transport"]}&`;
    }
    if (route.query["occasion"]) {
      queryTemp = `${queryTemp}filter[attribute][occasion]=${route.query["occasion"]}&`;
    }
    if (route.query["languages"]) {
      queryTemp = `${queryTemp}filter[attribute][languages]=${route.query["languages"]}&`;
    }
    if (route.query.rate) {
      queryTemp = `${queryTemp}filter[rating]=${route.query.rate}&`;
    }
    if (route.query.capacity) {
      queryTemp = `${queryTemp}filter[capacity]=${route.query.capacity}&`;
    }
    if (route.query.price_range) {
      const priceRange = route.query.price_range as string;
      const [minPrice, maxPrice] = priceRange.split("-");
      queryTemp = `${queryTemp}filter[min_price]=${minPrice}&filter[max_price]=${maxPrice}&`;
    }
  }
  return queryTemp;
}
const site = useSiteConfig();
const localePath = useLocalePath();
useSeoMeta({
  title: categoryMetaTags.value
    ? categoryMetaTags.value.title
    : `${activeCategory.value ? `${activeCategory.value.title} | ${site.name}` : ""}`,
  ogTitle: categoryMetaTags.value
    ? categoryMetaTags.value.title
    : `${activeCategory.value ? `${activeCategory.value.title} | ${site.name}` : ""}`,
  ogDescription: categoryMetaTags.value?.description
    ? categoryMetaTags.value.description
    : activeCategory.value
      ? `${t("discover.exploreTheBest")} ${activeCategory.value.title} ${t("experiences")}`
      : `${t("discover.allTheBest")} ${t("discover.toursActivitiesWorldwide")}`,
  description: categoryMetaTags.value?.description
    ? categoryMetaTags.value.description
    : activeCategory.value
      ? `${t("discover.exploreTheBest")} ${activeCategory.value.title} ${t("experiences")}`
      : `${t("discover.allTheBest")} ${t("discover.toursActivitiesWorldwide")}`,
  ogUrl: site.url.replace(/\/+$/, "") + route.fullPath,
});
const socialMedia = site.company.social_medias.map((item) => item.url);
const comments: ITestimonial[] =
  (runtimeConfig.public.statics as any)?.testimonials ?? [];
useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(
        useOrganizationSchema(categoryMetaTags.value, socialMedia, comments)
      ),
    },
    {
      type: "application/ld+json",
      children: JSON.stringify(
        useLocalBusinessSchema(categoryMetaTags.value, socialMedia, comments)
      ),
    },
    ...(products.value?.length
      ? [
          {
            type: "application/ld+json",
            children: JSON.stringify(
              useProductListSchema(
                (products.value ?? []).flatMap((rec) => rec ?? []),
                categoryMetaTags.value?.title,
                categoryMetaTags.value?.description,
                site.url.replace(/\/+$/, "") + route.fullPath,
                isSupplierLayout(layout),
                (path) => site.url.replace(/\/+$/, "") + localePath(path)
              )
            ),
          },
        ]
      : []),
  ],
});
</script>
<style lang="scss">
.dark-mode {
  .category-tag {
    @apply bg-white;
    &.is-active {
      @apply bg-primary-2;
    }
  }
  .category-only {
    p,
    h1 div {
      @apply text-title-color;
    }
  }
}
</style>
